
  import { ref } from 'vue';
  import { Options, Vue } from 'vue-class-component';
  import { FilterMatchMode } from 'primevue/api';
  import { ReportsModule, ReportsStore, MailLogEntry } from '@/store/reports';
  import { AccountModule, AccountStore } from '@/store/account';
  import moment from 'moment';

  @Options({})
  export default class MailLog extends Vue {
    private reportsStore: ReportsModule = ReportsStore;
    private accountStore: AccountModule = AccountStore;

    items: MailLogEntry[] = [];
    selectedRows: MailLogEntry[] = [];
    loading = false;
    globalFilter = ['email', 'fullName', 'subject', 'notes'];

    filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    get isAdmin() {
      return this.accountStore.isAdmin;
    }

    get deleteLabel() {
      const count = this.selectedRows ? this.selectedRows.length : 0;
      return count > 0 ? `Delete Selected (${count})` : 'Delete Selected';
    }

    formatDate(date: string) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss') : '';
    }

    deleteSelected(event) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return;
      }

      const ids = this.selectedRows.map((r) => r.mailLogId);

      this.$confirm.require({
        target: event.currentTarget,
        message: `Are you sure you want to permanently delete ${ids.length} mail log ${
          ids.length === 1 ? 'entry' : 'entries'
        }?`,
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          const deleted = await this.reportsStore.deleteMailLogs(ids);
          if (deleted > 0) {
            this.items = this.items.filter((i) => !ids.includes(i.mailLogId));
            this.selectedRows = [];
          }
        },
        reject: () => {
          //no-op
        }
      });
    }

    async mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
      this.loading = true;
      this.items = await this.reportsStore.getMailLog();
      this.loading = false;
    }
  }
